export const ALLOCATION = {
    UNALLOCATED: undefined,
    CONTROL: '1',
    VERSION_B: '2',
    VERSION_C: '3',
};
